import { toast } from "react-toastify";
import SalesABI from "../../utils/salesDeployerABI.json";
import Environment from "../../utils/Environment";
import Web3 from "web3";
export const Provider = (type) => async (dispatch, state) => {
  var web3;
  if (type == "mm") {
    web3 = new Web3(Web3.givenProvider || "http://localhost8545");
  } else if (type == "bsc") {
    web3 = new Web3(window.BinanceChain || "http://localhost8545");
  }
  dispatch({
    type: "WEB3",
    payload: web3,
  });
};
export const UserDataAction =
  (userWalletAddress, balance, networkId) => async (dispatch, state) => {
    const { web3 = new Web3(Web3.givenProvider || "http://localhost8545") } =
      state().UserReducer;

    const salesContract = await new web3.eth.Contract(
      SalesABI,
      Environment.saleContractAddress
    );

    if (userWalletAddress) {
      dispatch({
        type: "USER_WALLET_ADDRESS",
        payload: userWalletAddress,
      });
      dispatch({
        type: "NETWORK",
        payload:
          networkId == 97
            ? "BSC-Test Network"
            : networkId == 51 && "BSC Network",
      });
      dispatch({
        type: "BNB_BALANCE",
        payload: balance,
      });
    }

    dispatch({
      type: "SALES_CONTRACT",
      payload: salesContract,
    });
  };

export const disconnect = () => async (dispatch) => {
  dispatch({
    type: "DISCONNECT",
    payload: "",
  });
};

export const iodData = (data) => async (dispatch) => {
  dispatch({
    type: "IOD_DATA",
    payload: data,
  });
};
